export default __webpack_public_path__ + "static/media/hexoscope-logo-rectangle.4c14cd4e.svg";